import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

interface ISensorTypeKeys {
  locationIds?: Array<number>;
}

interface ISensorTypeSummary {
  count: number;
  name: string;
}

export const equipmentsSensorTypeSummaryKey = (locationIds?: Array<number>) => [
  'equipmentLogList',
  locationIds,
];

const equipmentsSensorTypeSummaryFn = ({ queryKey }: QueryFunctionContext) =>
  apiClient.get(`${APP_API_URL_V2}fsd/sensor-statistic/by-version-types`, {
    params: { locationIds: queryKey[1] },
  });

const equipmentsSensorTypeSummarySelect = ({ data }: AxiosResponse<{ data: ISensorTypeSummary[] }>) => {
  const totalSensors = data.data.reduce((total, sensorInfo) => total + sensorInfo.count, 0);

  return { ...data, total: totalSensors };
};

export const equipmentsSensorTypeSummaryQuery = ({ locationIds }: ISensorTypeKeys) => {
  return useQuery({
    queryKey: equipmentsSensorTypeSummaryKey(locationIds),
    queryFn: equipmentsSensorTypeSummaryFn,
    select: equipmentsSensorTypeSummarySelect,
  });
};
